export const OPENTABLE_FORM_COPY = {
  setupGuide: {
    ridLabel: 'Restaurant ID (RID)',
    ridHelperText: (url: string, rid: string) =>
      `Enter your RID to jump directly to the PolyAI integration page. Find it in the URL of your OpenTable Guest Center — e.g. ${url}/${rid}/... — or in OpenTable Admin under Restaurant Profile.`,
    ridInputHelp:
      'Find your RID in the URL of your OpenTable Guest Center or in\nOpenTable Admin under Restaurant Profile.',
    ridInputPlaceholder: 'e.g. 12345',
    ridInvalidInputError: 'Entered RID is invalid. Please enter numbers only.',
    ridTipText: `Tip: your RID appears in the URL once you're on your restaurant's page — enter it above to get a direct link next time.`,
    step1WithRid: {
      title: 'Step 1 — Go to your PolyAI integration page',
      description: (rid: string) =>
        `Opens directly to the PolyAI integration page for restaurant ${rid} in your OpenTable Guest Center`,
    },
    step1Login: {
      title: 'Step 1 — Log in to OpenTable Guest Center',
      description: 'Sign in to your account at guestcenter.opentable.com',
    },
    step2Navigate: {
      title: 'Step 2 — Navigate to your restaurant',
      description:
        'Select your restaurant from the list, then go to Integrations → Phone Automation and select PolyAI.',
    },
    stepFlowCompletion: (stepNumber: number) => ({
      title: `Step ${stepNumber} — Complete the PolyAI onboarding flow`,
      steps: [
        ['sign-up', 'Sign up — Create your PolyAI account.'],
        [
          'enter-details',
          'Enter your details — Provide your name, company, and role.',
        ],
        [
          'set-timezone',
          'Set your timezone — Select the timezone your restaurant operates in.',
        ],
        [
          'add-website',
          'Add your website URL (optional) — PolyAI will scrape your site to pre-populate FAQ content. If left blank, your OpenTable page will be used instead.',
        ],
        [
          'choose-voice',
          'Choose a voice — Select the voice your agent will use when handling calls.',
        ],
      ],
    }),
    stepReturn: (stepNumber: number) => ({
      title: `Step ${stepNumber} — Return to OpenTable & log in to PolyAI`,
      description:
        'After setup, you\'ll be redirected back to OpenTable. Click "Log in to PolyAI" to access your new Agent Studio.',
    }),
    stepReview: (stepNumber: number) => ({
      title: `Step ${stepNumber} — Review your pre-filled configuration`,
      description:
        "You'll land in Agent Studio with your restaurant details already pre-filled — walk-in policy, pet policy, opening hours, and more — scraped from your OpenTable page. Review and adjust before going live.",
    }),
    troubleshooting: {
      title: 'Having trouble?',
      description:
        'If you are redirected to the Agent Studio login page instead of completing the flow, try using Chrome on a personal (non-company) device. Some company browser policies can interfere with the redirect.',
    },
    additionalLocations: {
      title: 'Adding more locations?',
      description:
        'Each restaurant location needs its own connection. To add another site, enter its RID above and repeat this process — the steps are identical for every location.',
    },
  },
  formConfig: {
    stepTitle: 'Connect via OpenTable Guest Center',
    stepDescription:
      'Set up the PolyAI integration through your OpenTable Guest Center account.',
    connectButtonLabel: 'Close',
  },
};
